let ol = require('openlayers');
let jsts = require('jsts/dist/jsts');
let parser = new jsts.io.OL3Parser(undefined, ol);

let AbstractOperation = require('../operations/abstract');
let IsIntersectedResult = require('../operations/types/isIntersectedResult');

/**
 * Класс IsIntersected
 * @extends AbstractOperation
 */
class IsIntersected extends AbstractOperation {

  /**
   * Создает экземпляр класса IsIntersected
   */
  constructor() {
    super()
  }

  /**
   *
   * @param featureA
   * @param featureB
   * @return {boolean}
   */
  execute(featureA, featureB) {
    let isIntersected = operation(featureA, featureB);

    return new IsIntersectedResult({
      result: isIntersected
    })
  }
}

function operation(featureA, featureB) {
  let geomA = parser.read(featureA.getGeometry());
  let geomB = parser.read(featureB.getGeometry());
  let result = geomA.intersects(geomB);
  return result;
}

module.exports = IsIntersected;